var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Page1'),_c('Page2',{ref:"page2"}),_c('Page3',{ref:"page3"}),_c('Page4'),_c('Page5'),_c('Page6'),_c('Page7'),_c('Page8')],1)}
var staticRenderFns = []

export { render, staticRenderFns }